import type { PatchUserUiPreferencesPayload } from '@/api'
import {
  DEFAULT_UI_PREFERENCES,
  mergeUiPreferences,
  normalizeUiPreferences,
  readUiPreferencesCache,
  writeUiPreferencesCache,
  type NormalizedUiPreferences,
} from '@/lib/userUiPreferences'

type Listener = () => void

let current: NormalizedUiPreferences = readUiPreferencesCache() ?? DEFAULT_UI_PREFERENCES
let hydrated = false
const listeners = new Set<Listener>()

export function getUiPreferencesSnapshot(): NormalizedUiPreferences {
  return current
}

export function getUiPreferencesHydrated(): boolean {
  return hydrated
}

export function setUiPreferencesSnapshot(next: NormalizedUiPreferences) {
  current = next
  writeUiPreferencesCache(next)
  listeners.forEach((listener) => listener())
}

export function applyUiPreferencesPatch(patch: PatchUserUiPreferencesPayload): NormalizedUiPreferences {
  const next = mergeUiPreferences(current, patch)
  setUiPreferencesSnapshot(next)
  return next
}

export function replaceUiPreferencesSnapshot(stored: unknown): NormalizedUiPreferences {
  const next = normalizeUiPreferences(stored)
  hydrated = true
  setUiPreferencesSnapshot(next)
  return next
}

export function subscribeUiPreferences(listener: Listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
